import axios from 'axios';

// .envから環境変数を取得
const CHOWA_API_KEY = process.env.REACT_APP_CHOWA_API_KEY;
const ENGINE_HOURS_API = process.env.REACT_APP_ENGINE_HOURS_API;
const OPERATION_DAYS_API = process.env.REACT_APP_OPERATION_DAYS_API;

// 共通ヘッダー（APIキーを自動付与）
const getHeaders = () => ({
  'X-API-KEY': CHOWA_API_KEY,
  'Content-Type': 'application/json',
});

// ==============================================
// Chowa API関数群
// ==============================================

/**
 * エンジン稼働時間取得API
 * @param {string} model - モデル名（例: 'SR-60'）
 * @returns {Promise} APIレスポンス
 */
export const getEngineHours = (model) => {
  return axios.get(`${ENGINE_HOURS_API}?model_series=${encodeURIComponent(model)}`, {
    headers: getHeaders(),
  });
};

/**
 * 稼働日数取得API
 * @param {string} model - モデル名（例: 'SR-60'）
 * @returns {Promise} APIレスポンス
 */
export const getOperationDays = (model) => {
  return axios.get(`${OPERATION_DAYS_API}?model_series=${encodeURIComponent(model)}`, {
    headers: getHeaders(),
  });
};

/**
 * 全エンジン稼働時間取得API（モデル指定なし）
 * @returns {Promise} APIレスポンス
 */
export const getAllEngineHours = () => {
  return axios.get(ENGINE_HOURS_API, {
    headers: getHeaders(),
  });
};

/**
 * Promise.allで2つのAPIを並行取得（よく使われるパターン）
 * @param {string} model - モデル名
 * @returns {Promise} [hoursResponse, daysResponse]
 */
export const getEngineDataCombined = (model) => {
  return Promise.all([
    getEngineHours(model),
    getOperationDays(model),
  ]);
};

// デフォルトエクスポート
export default {
  getEngineHours,
  getOperationDays,
  getAllEngineHours,
  getEngineDataCombined,
};
